

export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-32 bg-[#fafaf8]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Label */}
        <p
          className="text-xs uppercase tracking-[0.3em] text-gray-400 font-semibold mb-4"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          Who We Are
        </p>

        {/* Heading */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:gap-20">
          <div className="lg:w-full mb-10 lg:mb-0">
            <h2
              className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              A team dedicated to
              <br />
              <span className="text-emerald-500">iOS excellence</span>
            </h2>
            <div
              className="w-12 h-1 rounded-full mb-8"
              style={{ background: 'linear-gradient(90deg, #10b981, #14b8a6)' }}
            />
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-5">
              KOREN d.o.o. is a Slovenia-based software company specializing in the development
              of modern, high-performance applications for the iOS platform. Our team brings
              together seasoned engineers, designers, and security specialists united by a
              single mission: making mobile devices safer and smarter.
            </p>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed">
              We believe that every user deserves a fast, clean, and secure mobile experience.
              That belief drives every line of code we write — from our privacy-first VPN
              solution to our intelligent device Cleaner. We build tools that work quietly
              in the background so you can focus on what matters most.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
